import { baseApi as api } from 'shared/api/baseApi';
import { getCookie } from 'shared/utils';
const injectedRtkApi = api.injectEndpoints({
	endpoints: (build) => ({
		accountLanguageCreate: build.mutation<AccountLanguageCreateApiResponse, AccountLanguageCreateApiArg>({
			query: (queryArg) => ({ url: `/api/account/language/`, method: 'POST', body: queryArg }),
		}),
		accountProfileRetrieve: build.query<AccountProfileRetrieveApiResponse, AccountProfileRetrieveApiArg>({
			query: () => ({ url: `/api/account/profile/` }),
		}),
		accountSettingsRetrieve: build.query<AccountSettingsRetrieveApiResponse, AccountSettingsRetrieveApiArg>({
			query: () => ({ url: `/api/account/settings/` }),
		}),
		accountSettingsUpdate: build.mutation<AccountSettingsUpdateApiResponse, AccountSettingsUpdateApiArg>({
			query: (queryArg) => ({ url: `/api/account/settings/`, method: 'PUT', body: queryArg }),
		}),
		accountSettingsPartialUpdate: build.mutation<
			AccountSettingsPartialUpdateApiResponse,
			AccountSettingsPartialUpdateApiArg
		>({
			query: (queryArg) => ({
				url: `/api/account/settings/`,
				method: 'PATCH',
				headers: { 'X-Csrftoken': getCookie('csrftoken') },
				body: queryArg,
			}),
		}),
	}),
	overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type AccountLanguageCreateApiResponse = unknown;
export type AccountLanguageCreateApiArg = Language;
export type AccountProfileRetrieveApiResponse = /** status 200  */ ProfileRead;
export type AccountProfileRetrieveApiArg = void;
export type AccountSettingsRetrieveApiResponse = /** status 200  */ AccountSettings;
export type AccountSettingsRetrieveApiArg = void;
export type AccountSettingsUpdateApiResponse = /** status 200  */ AccountSettings;
export type AccountSettingsUpdateApiArg = AccountSettings;
export type AccountSettingsPartialUpdateApiResponse = /** status 200  */ AccountSettings;
export type AccountSettingsPartialUpdateApiArg = PatchedAccountSettings;
export type Language = {
	language: LanguageEnum;
};
export type AccountManager = {
	first_name: string;
	last_name: string;
	email: string;
};
export type Profile = {
	account_manager: AccountManager | null;
	tg_first_name: string;
	tg_last_name: string;
	tg_username: string;
	tg_photo_url: string;
	actions_month: number;
	posts_month: number;
	brands_total: number;
	monthly_offer_count: number;
};
export type ProfileRead = {
	account_manager: AccountManager | null;
	tg_first_name: string;
	tg_last_name: string;
	tg_username: string;
	tg_photo_url: string;
	earned_month: string;
	actions_month: number;
	posts_month: number;
	earned_total: string;
	brands_total: number;
	monthly_offer_count: number;
};
export type AccountSettings = {
	bot_allow_send_digest?: boolean;
	bot_post_send_time?: BotPostSendTimeEnum;
	bot_notify_on_task_completion?: boolean;
	repeat_collection_posts?: boolean;
};
export type PatchedAccountSettings = {
	bot_allow_send_digest?: boolean;
	bot_post_send_time?: BotPostSendTimeEnum;
	bot_notify_on_task_completion?: boolean;
	repeat_collection_posts?: boolean;
};
export enum LanguageEnum {
	En = 'en',
	Ru = 'ru',
	Es = 'es',
}
export enum BotPostSendTimeEnum {
	$10 = '10',
	$30 = '30',
	$60 = '60',
	Never = 'never',
}
